import type { NextPage } from 'next';
import { LegalDisclaimerComponent } from 'ui';

const PageLegalDisclaimer: NextPage = () => {
	return <LegalDisclaimerComponent domain="www.descatalogados.org" />;
};

export default PageLegalDisclaimer;
